import React from 'react';
import {Platform, StyleSheet, Text, View} from "react-native";
import {isMobile} from "react-device-detect";
import { useLinkBuilder } from '@react-navigation/native';

import {appConfig, theme} from "../config";
import PropTypes from "prop-types";
import {navigationPropType} from "../propTypes";
import {Banner, ScrollIndicatorWrapper} from "../components/shared";
import translate, {availableLanguages} from "../services/localization";
import {Trans} from "../services/translationHelper";
import i18n from "i18n-js";
import {reduxStore} from "../store";
import {updateLanguage} from "../store/globals.slice";
import * as RNLocalize from "react-native-localize";
import {Routes} from "../navigation/constants";

function PrivacyPolicyScreen({ navigation }) {
    const buildLink = useLinkBuilder();

    reduxStore.dispatch(
        updateLanguage(
            RNLocalize.findBestAvailableLanguage(Object.keys(availableLanguages)),
        ),
    );
    console.log('locale', i18n.locale);
    console.log('loaded', Object.keys(i18n.translations || {}));
    console.log(
        i18n.translations?.en?.privacyPolicy?.content
    );
    return (
        <View style={[localStyle.flexi, localStyle.wrapper]}>
            {/* banner */}
            <Banner
                nav={navigation}
                title={translate('privacyPolicy').title}
                subTitle={translate('privacyPolicy').subTitle}
                noMenu
                isCheckIn={true}
                noWayBack={true}
            />
            {/* content */}
            <ScrollIndicatorWrapper>
                <View style={{ ...localStyle.wrapper, ...localStyle.top }}>
                    <Text style={{fontSize: 15}}>
                        <Trans i18nKey='privacyPolicy.content'
                               values={{
                                   privacy_url: window.location.origin + buildLink(Routes.PRIVACY_POLICY),
                               }}
                               components={{
                                   strong: <Text style={{ fontWeight: "bold" }}/>,
                                   header: <Text style={{ fontWeight: "bold", fontSize: 20 }}/>,
                                   subheader: <Text style={{ fontWeight: "bold", fontSize: 18 }}/>,
                                   item: ({ children, bullet }) => (
                                       <View style={{ flexDirection: 'row', paddingLeft: 30 }}>
                                           {bullet}
                                           <Text style={{ flex: 1 }}>{children}</Text>
                                       </View>
                                   ),
                                   subitem: ({ children, bullet }) => (
                                       <View style={{ flexDirection: 'row', paddingLeft: 60 }}>
                                           {bullet}
                                           <Text style={{ flex: 1 }}>{children}</Text>
                                       </View>
                                   ),
                                   bullet: <Text style={{paddingRight: 8}}>•</Text>,
                                   privacy_url: (
                                       <Text
                                           style={{ color: theme.colors.success }}
                                           onPress={() => {
                                               navigation.navigate(Routes.PRIVACY_POLICY)
                                           }}
                                       />
                                   ),
                                   dsgvo_ch_1: (
                                       <Text
                                           style={{ color: theme.colors.success }}
                                           onPress={() => {
                                               window.open(
                                                   'https://dsgvo-gesetz.de/kapitel-1/'
                                               )
                                           }}
                                       />
                                   ),
                               }}
                        />
                    </Text>
                </View>
            </ScrollIndicatorWrapper>
        </View>
    );
}

PrivacyPolicyScreen.propTypes = {
    navigation: PropTypes.shape(navigationPropType).isRequired,
};

const localStyle = StyleSheet.create({
    wrapper: {
        height: '100%',
        width: Platform.OS === 'web' && isMobile ? '100%' : 1000,
        alignSelf: 'center',
        flexDirection: 'column',
        backgroundColor: theme.values.defaultBackgroundColor,
    },

    flexi: {
        flex: 1,
    },

    title: {
        ...theme.fonts.title,
        textAlign: 'center',
        alignSelf: 'center',
        color: theme.values.defaultTitleTextColor,
    },

    top: {
        paddingStart: 20,
        paddingEnd: 20,
        justifyContent: 'left',
        alignItems: 'left',
        paddingTop: appConfig.scaleUiFkt(15),
        marginBottom: appConfig.scaleUiFkt(35),
    },

    infoText: {
        marginTop: appConfig.scaleUiFkt(20),
        marginBottom: appConfig.scaleUiFkt(20),
        marginLeft: appConfig.scaleUiFkt(40),
        marginRight: appConfig.scaleUiFkt(40),
        textAlign: 'justify',
        alignSelf: 'auto',
        color: theme.colors.accent4,
        ...theme.fonts.body,
    },

    titleText: {
        width: '80%',
        textAlign: 'center',
        alignSelf: 'center',
        ...theme.fonts.header2,
    },
});

export default PrivacyPolicyScreen;
